(function () {
  function onVariant(event) {
    const variantId = event?.detail?.resource?.id || event?.detail?.variant?.id;
    let qtyMaxErrorWrapper = document.querySelector(
      '.buy-buttons-block [data-max-qty-text]',
    );
    if (qtyMaxErrorWrapper) qtyMaxErrorWrapper.textContent = '';
    if (!variantId) return;

    document.querySelectorAll('quantity-selector-component').forEach((comp) => {
      const input = comp.querySelector(
        '[ref="quantityInput"], input[type="number"]',
      );
      if (!input) return;

      const url = comp.dataset.productUrl || window.location.pathname;
      const sec = comp.dataset.sectionId || '';
      const qs = new URLSearchParams({ variant: String(variantId) });
      if (sec) qs.set('section_id', sec);

      fetch(`${url}?${qs.toString()}`)
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const scope = sec
            ? doc.querySelector(`#shopify-section-${sec}`) || doc
            : doc;

          const fetched =
            scope.querySelector(
              'quantity-selector-component [ref="quantityInput"]',
            ) ||
            scope.querySelector(
              'quantity-selector-component input[type="number"]',
            ) ||
            scope.querySelector('input[type="number"]');
          if (!fetched) return;

          const max = fetched.getAttribute('max');
          if (max != null) {
            input.setAttribute('max', max);
            input.setAttribute('data-max-qty', max);
          } else {
            input.removeAttribute('max');
            input.removeAttribute('data-max-qty');
          }
          input.removeAttribute('disabled');

          input.value = '1';

          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        })
        .catch(() => {});
    });
  }

  document.addEventListener(
    (window.ThemeEvents && window.ThemeEvents.variantUpdate) ||
      'variant:update',
    onVariant,
  );
  document.addEventListener('variantChange', onVariant);
  document.addEventListener('product:variant-change', onVariant);
})();
